// source: organizationclientportalsetting.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var Protos_common_pb = require('./common_pb.js');
goog.object.extend(proto, Protos_common_pb);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.ResultCase', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.UpdateStatusReplay', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.UpdateStatusRequest', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.UpdateStatusResponse', null, global);
goog.exportSymbol('proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.ResultCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.UpdateStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.displayName = 'proto.organization_client_portal_setting_endpoint.UpdateStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.displayName = 'proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.UpdateStatusReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.displayName = 'proto.organization_client_portal_setting_endpoint.UpdateStatusReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.displayName = 'proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.oneofGroups_);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.UpdateStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.displayName = 'proto.organization_client_portal_setting_endpoint.UpdateStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.oneofGroups_);
};
goog.inherits(proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.displayName = 'proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isactive: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.UpdateStatusRequest;
  return proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactive(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsactive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest} returns this
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool isActive = 2;
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.getIsactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusRequest} returns this
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusRequest.prototype.setIsactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest;
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    message: (f = msg.getMessage()) && Protos_common_pb.MessageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.UpdateStatusReplay;
  return proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 2:
      var value = new Protos_common_pb.MessageResponse;
      reader.readMessage(value,Protos_common_pb.MessageResponse.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.MessageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp updatedDate = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} returns this
*/
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.MessageResponse message = 2;
 * @return {?proto.common.MessageResponse}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.getMessage = function() {
  return /** @type{?proto.common.MessageResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.MessageResponse, 2));
};


/**
 * @param {?proto.common.MessageResponse|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} returns this
*/
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    isactive: (f = msg.getIsactive()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    createdby: (f = msg.getCreatedby()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay;
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsactive(value);
      break;
    case 3:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setCreatedby(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getIsactive();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 id = 1;
 * @return {number}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional google.protobuf.BoolValue isActive = 2;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.getIsactive = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 2));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
*/
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.setIsactive = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.clearIsactive = function() {
  return this.setIsactive(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.hasIsactive = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional common.ProfileResponse createdBy = 3;
 * @return {?proto.common.ProfileResponse}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.getCreatedby = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 3));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
*/
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.setCreatedby = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.clearCreatedby = function() {
  return this.setCreatedby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.hasCreatedby = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
*/
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.ResultCase}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.getResultCase = function() {
  return /** @type {proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.UpdateStatusResponse;
  return proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.organization_client_portal_setting_endpoint.UpdateStatusReplay;
      reader.readMessage(value,proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.organization_client_portal_setting_endpoint.UpdateStatusReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateStatusReplay success = 1;
 * @return {?proto.organization_client_portal_setting_endpoint.UpdateStatusReplay}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.getSuccess = function() {
  return /** @type{?proto.organization_client_portal_setting_endpoint.UpdateStatusReplay} */ (
    jspb.Message.getWrapperField(this, proto.organization_client_portal_setting_endpoint.UpdateStatusReplay, 1));
};


/**
 * @param {?proto.organization_client_portal_setting_endpoint.UpdateStatusReplay|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse} returns this
*/
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.UpdateStatusResponse} returns this
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.UpdateStatusResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.ResultCase}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.getResultCase = function() {
  return /** @type {proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: (f = msg.getSuccess()) && proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse;
  return proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay;
      reader.readMessage(value,proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetOrganizationClientPortalSettingReplay success = 1;
 * @return {?proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.getSuccess = function() {
  return /** @type{?proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay} */ (
    jspb.Message.getWrapperField(this, proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay, 1));
};


/**
 * @param {?proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingReplay|undefined} value
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse} returns this
*/
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse} returns this
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.organization_client_portal_setting_endpoint.GetOrganizationClientPortalSettingResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.organization_client_portal_setting_endpoint);
